import { v4 as uuidv4 } from "uuid";
import { NumberOutlined, SmileOutlined, StarOutlined } from "@ant-design/icons";
import * as yup from "yup";
import { API_FORMBRICKS_URL } from "../appConstants";
import QuestionsTab from "../components/SurveyView/CreateEditSurveyModal/QuestionsTab";

export const createEditSurveyTabs = [
    {
        key: "1",
        label: "Tab 1",
        children: <QuestionsTab />,
    },
    {
        key: "2",
        label: "Tab 2",
        children: "Content of Tab Pane 2",
    },
];

export const surveyStatuses = [
    {
        label: "Draft",
        value: "draft",
    },
    {
        label: "In progress",
        value: "inProgress",
    },
    {
        label: "Paused",
        value: "paused",
    },
    {
        label: "Completed",
        value: "completed",
    },
];

export const surveyDisplayOptions = [
    {
        label: "Show only once",
        value: "displayOnce",
    },
    {
        label: "Until they submit a response",
        value: "displayMultiple",
    },
    {
        label: "Every time, even after they submitted a response",
        value: "respondMultiple",
    },
];

export const questionTypes = [
    {
        label: "Free text",
        value: "openText",
    },
    {
        label: "Single-Select",
        value: "multipleChoiceSingle",
    },
    {
        label: "Multi-Select",
        value: "multipleChoiceMulti",
    },
    {
        label: "Net Promoter Score (NPS)",
        value: "nps",
    },
    // {
    //     label: "Call-to-Action",
    //     value: "cta",
    // },
    {
        label: "Rating",
        value: "rating",
    },
    {
        label: "Grid (single choice)",
        value: "gridChoiceSingle",
    },
    // {
    //     label: "Grid (multiply choice)",
    //     value: "gridChoiceMulti",
    // },
    // {
    //     label: "Consent",
    //     value: "consent",
    // },
];
export const questionInputType = [
    {
        label: "Text",
        value: "text",
    },
    {
        label: "Email",
        value: "email",
    },
    {
        label: "Url",
        value: "url",
    },
    {
        label: "Number",
        value: "number",
    },
    {
        label: "Phone",
        value: "phone",
    },
];

export const baseQuestionFields = {
    headline: "",
    subheader: "",
    required: true,
    image: "",
    buttonLabel: "Next",
    backButtonLabel: "Back",
};

export const multipleChoiceSingleShuffleOptions = [
    {
        label: "Keep current order",
        value: "none",
    },
    {
        label: "Randomize all",
        value: "all",
    },
    {
        label: "Randomize all except last option",
        value: "exceptLast",
    },
];

export const ratingScaleOptions = [
    {
        label: "Star",
        value: "star",
        icon: <StarOutlined />,
    },
    {
        label: "Number",
        value: "number",
        icon: <NumberOutlined />,
    },
    {
        label: "Smiley",
        value: "smiley",
        icon: <SmileOutlined />,
    },
];

export const generateNewChoice = (label) => ({
    id: uuidv4(),
    label: label || "",
});

export const generateDefaultPage = () => ({
    id: uuidv4(),
    headline: "",
    subheader: "",
    questions: [],
});

export const questionsDefault = {
    openText: {
        ...baseQuestionFields,
        type: "openText",
        placeholder: "",
        longAnswer: false,
        inputType: questionInputType[0].value,
    },
    multipleChoiceSingle: {
        ...baseQuestionFields,
        type: "multipleChoiceSingle",
        choices: [generateNewChoice()],
        shuffleOption: multipleChoiceSingleShuffleOptions[0].value,
    },
    multipleChoiceMulti: {
        ...baseQuestionFields,
        type: "multipleChoiceMulti",
        choices: [generateNewChoice()],
        shuffleOption: multipleChoiceSingleShuffleOptions[0].value,
    },
    rating: {
        ...baseQuestionFields,
        type: "rating",
        scale: ratingScaleOptions[0].value,
        range: 5,
        lowerLabel: "Not good",
        upperLabel: "Very good",
    },
    nps: {
        ...baseQuestionFields,
        type: "nps",
        lowerLabel: "Not at all likely",
        upperLabel: "Extremely likely",
    },
    gridChoiceSingle: {
        ...baseQuestionFields,
        type: "gridChoiceSingle",
        rows: [generateNewChoice("Row 1")],
        choices: [generateNewChoice("Choice 1")],
    },
    gridChoiceMulti: {
        ...baseQuestionFields,
        type: "gridChoiceMulti",
        rows: [generateNewChoice("Row 1")],
        choices: [generateNewChoice("Choice 1")],
    },
};

export const createSurveyValidationSchema = yup.object({
    name: yup.string().required("Please provide the survey name"),
    description: yup.string(),
    // project: yup.string().required("Please select the project"),
    status: yup.string(),
    displayOption: yup.string(),
    recontactDays: yup.number().nullable().min(1).max(365),
    pages: yup.array().of(
        yup.object({
            questions: yup
                .array()
                .min(1, "Please provide at least 1 question")
                .of(
                    yup.object({
                        type: yup.string().required(),
                        headline: yup
                            .string()
                            .required("Please provide the question title"),
                        subheader: yup.string(),
                        buttonLabel: yup
                            .string()
                            .required("Please provide the button label"),
                        backButtonLabel: yup
                            .string()
                            .required("Please provide the button label"),
                        required: yup.boolean(),
                        shuffleOption: yup.string().when("type", {
                            is: (value) =>
                                [
                                    "multipleChoiceMulti",
                                    "multipleChoiceSingle",
                                ].includes(value),
                            then: (schema) =>
                                schema.required(
                                    "Please provide shuffle option"
                                ),
                        }),
                        choices: yup
                            .array()
                            .min(2, "Please provide at least 2 choices")
                            .when("type", {
                                is: (value) =>
                                    [
                                        "multipleChoiceMulti",
                                        "multipleChoiceSingle",
                                        "gridChoiceSingle",
                                        "gridChoiceMulti",
                                    ].includes(value),
                                then: (schema) =>
                                    schema.of(
                                        yup.object().shape({
                                            label: yup
                                                .string()
                                                .required(
                                                    "Choice can't be empty"
                                                ),
                                        })
                                    ),
                            }),
                        rows: yup
                            .array()
                            .min(2, "Please provide at least 2 choices")
                            .when("type", {
                                is: (value) =>
                                    [
                                        "gridChoiceSingle",
                                        "gridChoiceMulti",
                                    ].includes(value),
                                then: (schema) =>
                                    schema.of(
                                        yup.object().shape({
                                            label: yup
                                                .string()
                                                .required("Row can't be empty"),
                                        })
                                    ),
                            }),
                        scale: yup.string().when("type", {
                            is: (value) => ["rating"].includes(value),
                            then: (schema) =>
                                schema.required("Please provide scale option"),
                        }),
                        lowerLabel: yup.string().when("type", {
                            is: (value) => ["rating", "nps"].includes(value),
                            then: (schema) =>
                                schema.required("Please provide Lower label"),
                        }),
                        upperLabel: yup.string().when("type", {
                            is: (value) => ["rating", "nps"].includes(value),
                            then: (schema) =>
                                schema.required("Please provide Upper label"),
                        }),
                        longAnswer: yup.boolean().when("type", {
                            is: (value) => ["openText"].includes(value),
                            then: (schema) => schema,
                        }),
                        inputType: yup.string().when("type", {
                            is: (value) => ["openText"].includes(value),
                            then: (schema) => schema,
                        }),
                    })
                ),
        })
    ),
});

export const openSurveyPreview = (id) => {
    window.open(`${API_FORMBRICKS_URL()}/s/${id}?preview=true`, "_blank");
};

export const copySurveyLink = (id) => {
    navigator.clipboard.writeText(`${API_FORMBRICKS_URL()}/s/${id}`);
};

export const transformResponsesData = (responses, questions) => {
    const newQuestionsArr = questions?.map((question) => ({
        ...question,
        responses: [],
    }));
    for (const response of responses) {
        for (const key in response.data) {
            const questionIndex = newQuestionsArr.findIndex(
                (item) => item.id === key
            );
            const newResponse = {
                id: response.id,
                answer: response.data[key],
                date: response.createdAt,
            };
            newQuestionsArr[questionIndex]?.responses.push(newResponse);
        }
    }
    return newQuestionsArr;
};

export const getQuestionsFromSurvey = (survey) => {
    const questions = [];
    survey.pages.forEach((page) => questions.push(...page.questions));
    return questions;
};

export const transformSingleResponseData = (question, label) => {
    const responsesCount = question.responses.filter((res) => {
        if (Array.isArray(res.answer)) {
            return res.answer.includes(label);
        }
        return res.answer === label;
    }).length;
    return {
        overallPercentage: parseInt(
            (responsesCount * 100) / question.responses.length
        ),
        count: responsesCount,
    };
};

export const createSurveyResposne = (question) => {
    const dummyStringInitial =
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.";

    const num1 = Math.ceil(Math.random() * dummyStringInitial.length);
    const num2 = Math.ceil(
        Math.random() * (dummyStringInitial.length - num1) + num1
    );
    if (question.type === "rating") {
        return Math.ceil(Math.random() * 5);
    }
    if (question.type === "nps") {
        return Math.ceil(Math.random() * 10);
    }
    if (question.type === "openText") {
        return dummyStringInitial.slice(num1, num2);
    }
    if (question.type === "multipleChoiceSingle") {
        const randomSelectIndex = Math.floor(
            Math.random() * question?.choices.length
        );
        return question?.choices[randomSelectIndex]?.label;
    }
    if (question.type === "multipleChoiceMulti") {
        const randomSelectIndex = Math.floor(
            Math.random() * question?.choices.length
        );
        return [question?.choices[randomSelectIndex]?.label];
    }
};

export const generateSurveyTemplate = ({
    name,
    pages,
    description,
    status,
}) => ({
    name,
    image: null,
    description: description || "",
    status: status || "inProgress",
    pages,
    questions: [],
    thankYouCard: {
        enabled: true,
        headline: "Thank you!",
        subheader: "We appreciate your feedback.",
    },
    productOverwrites: {
        brandColor: "#0396C2",
    },
    styling: {
        background: {
            bg: "#0396c214",
        },
    },
});
